/** The part of the Parse SDK this reads, so tests can hand in their own. */
interface ParseUserSource {
  User: { current(): { id?: string } | null | undefined }
}

/**
 * The id of the signed-in Parse user, or null. Read on every call, never kept: Parse has a user
 * before the Redux store does and drops them before it does, so caches that must not outlive or
 * cross an account (the list memo, account status, the background-effect preference) key on it.
 *
 * Takes the caller's own `Parse` import rather than importing one: `initializeParse` starts the
 * SDK as it loads, which the services that mock `parse` or `initializeParse` in tests must not
 * pick up through a shared module.
 */
export function parseUserId(parse: ParseUserSource): string | null {
  try {
    return parse.User.current()?.id ?? null
  } catch {
    return null
  }
}
